import {
    IconArrowDown,
    IconChevronDown,
    IconArrowLeft,
    IconArrowRight,
    IconFacebook,
    IconInstagram,
    IconMenu,
    IconTiktok,
    IconXMark,
    IconSneakerRunning,
} from '@/components/icons';
import IconBinoculars from '@/components/icons/IconBinoculars';
import IconTrain from '@/components/icons/IconTrain';
import IconGraduationCap from '@/components/icons/IconGraduationCap';
import IconBagShopping from '@/components/icons/IconBagShopping';
import IconRoute from '@/components/icons/IconRoute';
import IconBicycle from '@/components/icons/IconBicycle';
import IconPersonWalking from '@/components/icons/IconPersonWalking';
import IconPlateUtensils from '@/components/icons/IconPlateUtensils';
import IconBriefcaseMedical from '@/components/icons/IconBriefcaseMedical';
import IconCheckMarkCircle from '@/components/icons/IconCheckMarkCircle';
import IconTrees from '@/components/icons/IconTrees';
import IconTaxi from '@/components/icons/IconTaxi';
import IconTrainSubwayTunnel from '@/components/icons/IconTrainSubwayTunnel';

export const ICONS = {
    facebook: IconFacebook,
    instagram: IconInstagram,
    tiktok: IconTiktok,
    'x-mark': IconXMark,
    'arrow-down': IconArrowDown,
    'chevron-down': IconChevronDown,
    'arrow-right': IconArrowRight,
    'arrow-left': IconArrowLeft,
    menu: IconMenu,
    binoculars: IconBinoculars,
    train: IconTrain,
    'graduation-cap': IconGraduationCap,
    'bag-shopping': IconBagShopping,
    route: IconRoute,
    bicycle: IconBicycle,
    'person-walking': IconPersonWalking,
    'plate-utensils': IconPlateUtensils,
    'briefcase-medical': IconBriefcaseMedical,
    'check-mark-circle': IconCheckMarkCircle,
    trees: IconTrees,
    'sneaker-running': IconSneakerRunning,
    taxi: IconTaxi,
    'train-subway-tunnel': IconTrainSubwayTunnel,
};

export type IconName = keyof typeof ICONS;

export function isIconName(value: unknown): value is IconName {
    return typeof value === 'string' && value in ICONS;
}
